export const APPLICATION_UPDATE_TYPE = {
  EVENT: 'EVENT',
  STATUS: 'STATUS',
  ALLIANZ_INSURANCE: 'ALLIANZ_INSURANCE',
  ALI_INSURANCE: 'ALI_INSURANCE',
  EXPECTED_SETTLEMENT_DATE: 'EXPECTED_SETTLEMENT_DATE',
};

export default null;
